module.exports = __webpack_public_path__ + "1c47eaa0ee1de8087943a3ea966216eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/3.jpg
// module id = 268
// module chunks = 0